import React from 'react'
import AutoMapSuccess from '../Components/AutoMapSuccessMessage/AutoMapSuccess'

const AutoMapSuccessView = () => {
  return (
    <div>
        <AutoMapSuccess />
    </div>
  )
}

export default AutoMapSuccessView